import React from "react";
import NavBar from "./NavBar";

import SideBar from "./SideBar";

import { Toolbar } from "@material-ui/core";

import { useStyles } from "../styles/mainStyles";
import useInterval from "use-interval";
import { connect } from "react-redux";
import { getActive_Ready_Orders } from "../redux/Orders/ordersActions";
import Store from "../redux/Store";
import {
  findActiveOrders,
  findReadyToSendOrders,
  popupMessagesHandler,
  set_active_ready_orders_Length,
  set_Refresh,
} from "../redux/Orders/OrderActionCreators";
import notification from "../styles/notification.wav";

function Layout({ children, refresh, letRefresh, active_ready_length }) {
  const classes = useStyles();
  const [width, setWidth] = React.useState(window.innerWidth);
  const [sideBarStatus, setSideBarStatus] = React.useState(false);
  const [ordersLength, setOrdersLength] = React.useState(0);
  const audio = new Audio(notification);
  const timer =
    localStorage.recall_interval_timer !== undefined
      ? Number(localStorage.recall_interval_timer)
      : 100;
  // ---------------------------------------------------------------------------socket

  // ---------------------------------------------------------------------------socket

  let layoutRef = React.useRef();
  // ---------------------------------------------------------------------------set window width
  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", () => {
        setWidth(window.innerWidth);
      });
    };
  }, []);

  // --------------------------------------------------------------------------- timer use Efect

  useInterval(
    () => {
      Store.dispatch(set_Refresh(refresh + 1));
    },
    1000 * timer,
    true
  );

  // // --------------------------------------------------------------------------- seting lengths for sibar and notification sound
  React.useEffect(() => {
    if (letRefresh) {
      getActive_Ready_Orders().then((res) => {
        if (!res) return;
        Store.dispatch(
          set_active_ready_orders_Length({
            active: res.activeOrders.length,
            ready: res.ReadyOrders.length,
          })
        );
        Store.dispatch(findActiveOrders({ data: res.activeOrders }));
        Store.dispatch(findReadyToSendOrders({ data: res.ReadyOrders }));
      });
    }
    // eslint-disable-next-line
  }, [refresh]);

  // ---------------------------------------------------------------------------notification audio
  React.useLayoutEffect(() => {
    if (active_ready_length.active > ordersLength) {
      const count = active_ready_length.active - ordersLength;
      setOrdersLength(active_ready_length.active);

      audio
        .play()
        .then((res) => {})
        .catch((err) => {});
      Store.dispatch(
        popupMessagesHandler({
          mode: true,
          message: `${count} سفارش جدید`,
          color: "info",
        })
      );
    } else if (active_ready_length.active < ordersLength) {
      setOrdersLength(active_ready_length.active);
    }
    // eslint-disable-next-line
  }, [active_ready_length.active]);
  return (
    <>
      <div className={classes.LayoutRoot} ref={layoutRef}>
        <NavBar
          setOpen={setSideBarStatus}
          width={width}
          layoutRef={layoutRef}
        />
        <SideBar
          width={width}
          sideStatus={sideBarStatus}
          setSideStatus={setSideBarStatus}
        />
        <div className={classes.LayoutChildren}>
          <Toolbar />

          {children}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (props) => {
  const { OrderReducer, searchReducer, loginReducer } = props;

  const {
    popupMessages,
    refresh,
    letRefresh,
    activeOrders,
    readyToSendOrders,
    active_ready_length,
  } = OrderReducer;
  const { officeAuth, pwa_install } = loginReducer;

  return {
    searchReducer,
    popupMessages,
    refresh,
    letRefresh,
    activeOrders,
    officeAuth,
    readyToSendOrders,
    active_ready_length,
    pwa_install,
  };
};

export default connect(mapStateToProps)(Layout);
